export default __webpack_public_path__ + "static/media/sp-dropdown.8ce29063.webp";